import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { LoyaltyProgram } from '~/composables/api/basket'

export const useCartDialogStore = defineStore('cartDialog', () => {
  const isOpen = ref(false)
  const selectedLoyaltyProgram = ref<LoyaltyProgram>()

  const open = () => {
    isOpen.value = true
  }
  const close = () => {
    isOpen.value = false
  }

  return { open, close, isOpen, selectedLoyaltyProgram }
})
